import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import TimesheetTablePayrollPDF from '../../../components/Reports/Timesheets/TimesheetTablePayrollPDF'
import { Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';
import { useUser } from '../../../../providers/UserContext';
import { firestore } from '../../../../firebase/firebase';
import { connect } from 'react-redux';
import * as actionCreators from '../../../../store/actions/index';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        width: '100%',
        padding: '32px',
        justifyContent: 'center',
        marginTop: '40px',
    },
}));

function TimesheetTablePayrollPrint(props) {
    const classes = useStyles();
    const { getUsers, users } = useUser();

    const [loading, setLoading] = useState([]);
    const [fullData, setFullData] = useState([]);
    const [marking, setMarking] = useState(false);
    const [payable, setPayable] = useState([])
    const [markingProcess, setMarkingProcess] = useState(false)

    useEffect(() => {
        setLoading(true);
        if(users.length <= 0){
            getUsers();
        }
        setFullData(props.location.state)
        setPayable(checkPayable(props.location.state.timesheetData))
        setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.state]);

    //returns timesheets available for the paid bool
    const checkPayable = (timesheetsArg) => {
        let payableContainer = []
        timesheetsArg.forEach((timesheet) => {
            if(timesheet.submitted && timesheet.approved && timesheet.payrolled && !timesheet.paid){
                payableContainer.push(timesheet)
            }
        })
        return payableContainer
    }

    const markAsPaidModalChanged = (bool) => {
        setMarking(bool)
    }

    //needs to check if item is payrolled, approved, ect
    const markAsPaid = () => {
        setMarkingProcess(true)
        let batch = firestore.batch();
        payable.forEach((timesheet) => {
            let docRef = firestore.collection('timesheets').doc(timesheet.docId);
            batch.update(docRef, {paid: true});
        })
        batch.commit().then(() => {
            //update the timesheets in timesheetData and filteredData in sessionStorage
            let updatedTimesheetData = fullData.timesheetData.map((timesheet) => { return {...timesheet, paid: true} })
            setPayable(checkPayable(updatedTimesheetData))
            let updatedFullData = {...fullData, timesheetData: updatedTimesheetData}
            setFullData(updatedFullData)
            markAsPaidModalChanged(false)

            //find all timesheets in sessionStorage's filteredData that match the timesheets in timesheetData and update them
            let filteredData = _.cloneDeep(props.timesheetData)
            let updatedFilteredData = filteredData.map((timesheet) => {
                let match = updatedTimesheetData.find((updatedTimesheet) => updatedTimesheet.docId === timesheet.docId)
                if(match){
                    return {...timesheet, paid: true}
                }
                return timesheet
            })
            props.updateTableCache('timesheetReport', {timesheetData: updatedFilteredData, unitData: props.unitData, jobData: props.jobData})
            props.history.push('/dashboard/reporting');
            setMarkingProcess(false)
        })
    }

    return (
        loading
            ? 
            <div className={classes.content}>
                <Skeleton variant='rect' width={'63vw'} height={'80vh'} />
            </div>
            : 
            <TimesheetTablePayrollPDF
                //timesheetData={timesheetData}
                users={users} 
                marking={marking}
                setMarking={setMarking}
                markAsPaidModalChanged={markAsPaidModalChanged}
                markAsPaid={markAsPaid}
                fullData={fullData} 
                payable={payable}
                markingProcess={markingProcess}
            />
    )
}

//Map slice of global state to props
const mapStateToProps = (state) => {
    return {
        // state refers to global state/ redux state (acts somewhat like singleton)
        // "products" is the name given in index.js to the state of our reducer
        // the props: featuredProducts and loading come from the reducer productsReducer.js
        //cart: state.cart.cart,

        jobData: state.tableCache.timesheetReport.jobData,
        unitData: state.tableCache.timesheetReport.unitData,
        timesheetData: state.tableCache.timesheetReport.timesheetData,

        //tableCachedData: state.tableCache.timesheetReport,
    };
}

//map our dispatch functions to props
const mapDispatchToProps = dispatch => {
    return {
        updateTableCache: (tableKey, tableValue) => dispatch(actionCreators.updateTableCache(tableKey, tableValue)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TimesheetTablePayrollPrint));